import styles from './skeletonCell.module.scss'

export const SkeletonCell = () => {
	return (
		<div className={styles.skeleton} />
	)
}
